var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-roles-content"},[_c('rp-roles-header'),_c('rp-roles-control')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }